import { Component } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";

@Component({
  selector: 'app-error-dialog',
  template: `
<section class="error-dialog" aria-labelledby="error-dialog-title">
  <div class="error-dialog__icon-wrap" aria-hidden="true">
    <i class="bi bi-x-circle-fill error-dialog__icon"></i>
  </div>

  <div class="error-dialog__content">
    <h2 id="error-dialog-title" class="error-dialog__title">
      {{ title }}
    </h2>
    <p class="error-dialog__message">
      {{ message }}
    </p>
  </div>

  <div class="error-dialog__actions">
    <button
      type="button"
      class="error-dialog__button"
      (click)="closeDialog()"
      autofocus
    >
      OK
    </button>
  </div>
</section>

    `,

    styles:[`:host {
  display: block;
  color: var(--ca-text-primary, #202938);
}

.error-dialog {
  box-sizing: border-box;
  width: 100%;
  max-width: 32rem;
  padding: 0.5rem 0.75rem 0.75rem;
  color: var(--ca-text-primary, #202938);
  background: var(--ca-surface, #ffffff);
  text-align: center;
}

.error-dialog__icon-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 4.5rem;
  height: 4.5rem;
  margin: 0 auto 1.25rem;
  border: 1px solid var(--ca-danger, #dc3545);
  border-radius: 50%;
  background-color: var(--ca-danger-bg, #fff0f1);
}

.error-dialog__icon {
  display: block;
  color: var(--ca-danger, #dc3545);
  font-size: 2.15rem;
  line-height: 1;
}

.error-dialog__content {
  max-width: 27rem;
  margin: 0 auto;
}

.error-dialog__title {
  margin: 0 0 0.625rem;
  color: var(--ca-text-primary, #202938);
  font-size: clamp(1.4rem, 3vw, 1.7rem);
  font-weight: 700;
  line-height: 1.25;
  letter-spacing: -0.015em;
  overflow-wrap: anywhere;
}

.error-dialog__message {
  margin: 0;
  color: var(--ca-text-secondary, #5c6675);
  font-size: 1rem;
  line-height: 1.65;
  overflow-wrap: anywhere;
}

.error-dialog__actions {
  display: flex;
  justify-content: center;
  margin-top: 1.75rem;
}

.error-dialog__button {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 7rem;
  min-height: 2.75rem;
  padding: 0.7rem 1.75rem;
  border: 1px solid var(--ca-primary, #0060d6);
  border-radius: var(--ca-radius-md, 0.5rem);
  background-color: var(--ca-primary, #0060d6);
  color: #ffffff;
  font: inherit;
  font-size: 0.95rem;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    transform 0.2s ease;
}

.error-dialog__button:hover {
  border-color: var(--ca-primary-dark, #1a1a86);
  background-color: var(--ca-primary-dark, #1a1a86);
}

.error-dialog__button:active {
  transform: translateY(1px);
}

.error-dialog__button:focus-visible {
  outline: 3px solid var(--ca-primary-light, #b8d8ff);
  outline-offset: 3px;
  box-shadow: 0 0 0 4px rgba(0, 96, 214, 0.14);
}

@media (max-width: 480px) {
  .error-dialog {
    padding: 0.25rem 0.25rem 0.5rem;
  }

  .error-dialog__icon-wrap {
    width: 3.75rem;
    height: 3.75rem;
    margin-bottom: 1rem;
  }

  .error-dialog__icon {
    font-size: 1.85rem;
  }

  .error-dialog__message {
    font-size: 0.9375rem;
  }

  .error-dialog__actions {
    margin-top: 1.4rem;
  }
}

@media (prefers-reduced-motion: reduce) {
  .error-dialog__button {
    transition: none;
  }
}
`]
})
export class ErrorDialogComponent {
  readonly title = 'Error';
  readonly message = 'An error occurred while performing the operation.';
  constructor(
    private dialog: MatDialog,
    private router: Router
  ) { }

  closeDialog() {

    this.dialog.closeAll();

  }
}